const sanitizerConfig = {
  allowedTags: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "p",
    "a",
    "ul",
    "ol",
    "nl",
    "li",
    "b",
    "i",
    "strong",
    "em",
    "strike",
    "abbr",
    "code",
    "hr",
    "br",
    "div",
    "table",
    "thead",
    "caption",
    "tbody",
    "tr",
    "th",
    "td",
    "pre",
    "iframe",
    "figure",
    "picture",
    "source",
    "noscript",
    "img",
    "input",
    "textarea",
    "hr",
    "label"
  ],
  disallowedTagsMode: "discard",
  allowedAttributes: {
    a: ["href", "name", "target"],
    img: ["src","srcset","alt","loading","sizes","aria-hidden","style"],
    div: ["class","style","data-reactroot","aria-hidden", "role", "id", "lang", "dir", "aria-live"],
    figure: ["class"],
    source: ["srcset","sizes"],
    input: ["type", "class", "name", "id", "value", "size", "aria-required", "aria-invalid", "placeholder"],
    textarea: ["cols", "rows", "class", "name", "size", "aria-invalid", "placeholder"],
    iframe: ["src", "frameborder", "style"],
    form: ["action", "method", "class", "novalidate"],
    span: ["class"],
    h1: ["form_header", "form_footer"]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [
    "img",
    "br",
    "hr",
    "area",
    "base",
    "basefont",
    "input",
    "link",
    "meta",
  ],
  // URL schemes we permit
  allowedSchemes: ["http", "https", "ftp", "mailto"],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
  allowProtocolRelative: true,
  enforceHtmlBoundary: false,
}

export default sanitizerConfig